import { CategoryDTO } from '@/api/dto/CategoryDTO';
import { CrudEndpoint } from '@/api/common/CrudEndpoint';

export class CategoryCRUD extends CrudEndpoint<CategoryDTO> {
  constructor() {
    super('category');
  }
}
